import { render, staticRenderFns } from "./Chapter8_4.vue?vue&type=template&id=6706e00a&scoped=true&"
import script from "./Chapter8_4.vue?vue&type=script&lang=js&"
export * from "./Chapter8_4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6706e00a",
  null
  
)

export default component.exports